var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"key",on:{"click":_vm.keyPressed}},[_vm._v("\n    "+_vm._s(_vm.inputKey)+"\n    "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }